<template>
    <v-card>
        <v-card-title>
            <v-container>
                <v-row>
                    <h3>Users</h3>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="newUserForm"
                                color="primary"
                                dark
                                fab
                            >
                                <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Invite New User</span>
                    </v-tooltip>
                </v-row>
                <v-row>
                    <v-col v-if="isSuperAdmin">
                        <v-checkbox
                            style="margin-right: 15px;"
                            v-model="showSwitchUsers"
                            label="Only Switchable Users"
                        />
                    </v-col>
                    <v-col v-if="isSuperAdmin">
                        <v-select
                            :items="user_types"
                            item-text="value"
                            item-value="id"
                            v-model="user_type"
                            label="User Type"
                            clearable
                            hide-details
                            :menu-props="{ nudgeBottom: 34 }"
                        />
                    </v-col>
                    <v-col v-if="isSuperAdmin">
                        <ApolloQuery
                            :query="
                                require('@/graphql/client/clientsDropdown.gql')
                            "
                        >
                            <template
                                v-slot="{ result: { loading, error, data } }"
                            >
                                <v-autocomplete
                                    v-if="data"
                                    :items="[
                                        { id: '0', name: 'No client' },
                                        ...data.allClients,
                                    ]"
                                    :loading="loading"
                                    item-text="name"
                                    item-value="id"
                                    v-model="client_id"
                                    label="Client"
                                    clearable
                                    hide-details
                                />
                                <v-autocomplete
                                    v-else
                                    label="Loading Clients"
                                />
                            </template>
                        </ApolloQuery>
                    </v-col>
                    <v-col v-if="isSuperAdmin">
                        <v-menu
                            v-model="showLastLoginPicker"
                            :close-on-content-click="false"
                            :nudge-bottom="20"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="lastLoginText"
                                    label="Last Login"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    class="datepicker"
                                    clearable
                                    hide-details
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="last_login" range>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="showLastLoginPicker = false"
                                    >Close</v-btn
                                >
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="keywords"
                            append-icon="mdi-magnify"
                            label="Search Users..."
                            clearable
                            single-line
                            hide-details
                        />
                    </v-col>
                    <v-btn
                        @click="clearFilters"
                        :disabled="!areActiveFilters"
                        class="align-self-center"
                        x-small
                        >Clear filters</v-btn
                    >
                </v-row>
            </v-container>
        </v-card-title>
        <v-card-text>
            <users-grid
                :keywords.sync="keywords"
                :client_id.sync="client_id"
                :user_type.sync="user_type"
                :last_login.sync="last_login"
                :showSwitchUsers.sync="showSwitchUsers"
                :reload.sync="reloadVar"
                @edit-user="editUser"
            />
        </v-card-text>
        <v-dialog v-model="userFormDialog" persistent max-width="600">
            <user-form
                :user.sync="formUser"
                @user-form-saved="userSaved"
                @user-form-closed="closeUserForm()"
            />
        </v-dialog>
    </v-card>
</template>
<script>
import UsersGrid from '@/views/users/UsersGrid'
import UserForm from '@/views/users/UserForm'
import moment from 'moment/moment'

export default {
    name: 'users',
    components: {
        'users-grid': UsersGrid,
        'user-form': UserForm,
    },
    computed: {
        isSuperAdmin() {
            return this.$store.getters.userForPortalAccess.user_type === 'admin'
        },
        lastLoginText: {
            get() {
                if (this.last_login.length) {
                    return this.last_login
                        .map(date => this.formatDate(date))
                        .join(' - ')
                }

                return ''
            },

            set(value) {
                if (value === null) {
                    this.last_login = []
                }
            },
        },
        areActiveFilters() {
            return (
                this.keywords ||
                this.showSwitchUsers ||
                this.user_type ||
                this.client_id ||
                this.last_login.length
            )
        },
    },
    data() {
        return {
            keywords: '',
            selectedUser: {},
            reloadVar: 0,
            client_id: this.$route.query.client_id || '',
            user_type: '',
            last_login: [],
            showLastLoginPicker: false,
            userFormDialog: false,
            formUser: {},
            showSwitchUsers: false,
            user_types: [
                {
                    id: 'admin',
                    value: 'Administrator',
                },
                {
                    id: 'client_admin',
                    value: 'Company Administrator',
                },
                {
                    id: 'client_user',
                    value: 'Company User',
                },
            ],
        }
    },
    methods: {
        reloadGrid: function() {
            this.reloadVar++
        },
        newUserForm: function() {
            this.formUser = {}
            this.userFormDialog = true
        },
        closeUserForm: function() {
            this.userFormDialog = false
        },
        closeUserInviteForm: function() {
            this.userInviteFormDialog = false
        },
        editUser: function(user) {
            this.formUser = user
            this.formUser.confirm_email = this.formUser.email
            this.userFormDialog = true
        },
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
        },
        userSaved: function(data) {
            this.closeUserForm()

            // If it's an update, do not reload the grid
            if (!data.data.hasOwnProperty('updateUser')) {
                this.reloadGrid()
            }
        },
        clearFilters() {
            this.showSwitchUsers = false
            this.user_type = ''
            this.client_id = ''
            this.last_login = []
            this.keywords = ''
        },
    },
}
</script>
